import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { OrderNumber } from '../../../shared/types';

@jsonObject
export class PublicBoxQuestionnaireOrderResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;
}
